import React from "react";

import { Popover } from "@base-ui/react/popover";

import { IconName } from "../icon";
import { Tooltip } from "../tooltip/tooltip";

import { FloatingBar } from "./floating-bar";
import { FloatingBarIcon } from "./floating-bar-icon";

import "./floating-bar-dropdown.css";

export function FloatingBarDropdown({
	iconName,
	toolTipText,
	open,
	disabled,
	children,
	onOpenChange,
}: {
	iconName: IconName;
	toolTipText?: string; // Now it was needed here, also place tooltip in FloatingBarButton?
	open?: boolean;
	disabled?: boolean;
	onOpenChange?: (open: boolean) => void;
	children: React.ReactNode;
}) {
	// Don't openOnHover, else a race with Tooltip
	return (
		<Popover.Root open={open} onOpenChange={onOpenChange}>
			<Popover.Trigger
				delay={500}
				render={(props, state) => (
					<Tooltip text={state.open ? undefined : toolTipText}>
						<FloatingBarIcon {...props} iconName={iconName} disabled={disabled} />
					</Tooltip>
				)}
			></Popover.Trigger>
			<Popover.Portal>
				<Popover.Backdrop />
				<Popover.Positioner className="floating-bar-dropdown">
					<Popover.Popup>
						<FloatingBar>{children}</FloatingBar>
					</Popover.Popup>
				</Popover.Positioner>
			</Popover.Portal>
		</Popover.Root>
	);
}
